import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconComponent } from '@shared-lib/components/icon/icon.component';

@Component({
  selector: 'cp-sign-in-code-error',
  templateUrl: './sign-in-code-error.component.html',
  styleUrl: './sign-in-code-error.component.scss',
  imports: [IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignInCodeErrorComponent {
  readonly isIncorrectCode = input.required<boolean>();
  readonly hasError = input.required<boolean>();
  readonly incorrectCodeHint = input.required<string>();
}
